import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import ScannerViewData from '../../models/scanner/ScannerViewData';
import { IScannerViewData } from '../../models/scanner/ScannerViewData';
import { IMapping } from "../../models/scanner/ScannerFormData";
import i18next from "i18next";

class ScannerActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async getById(id: string) {
        try {
            const request = new ApiRequest(`/settings/scanner/${id}`, "", null, i18next.t("Scanner data not found"));
            const result = await this.api.get(request);
            const payload = this.convertResponseData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SCANNER_SETTING_GET_BY_ID,
                payload: {
                    data: payload,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getAll(page: number, pageSize: number, sort: string, order: string, filter: string) {
        try {
            const request = new ApiRequest(`/settings/scanner/${page}/${pageSize}/${sort}/${order}/${filter}`, "", null, i18next.t("Unable to fetch scanners."));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SCANNER_SETTING_GET_ALL,
                payload: { data: payload, }
            });
        } catch (error) {
            throw error;
        }
    }

    async post(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.preparePostPayload(data);
            const request = new ApiRequest("/settings/scanner", requestId, payload, i18next.t("Scanner created."));
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SCANNER_SETTING_SUBMIT,
                payload: {
                    Id: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error
        }
    }

    async put(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.preparePutPayload(data);
            const request = new ApiRequest("/settings/scanner", requestId, payload, i18next.t("Scanner updated."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SCANNER_SETTING_SUBMIT,
                payload: {
                    Id: data.id,
                    message: i18next.t(["Scanner updated."])
                }
            });
        } catch (error) {
            throw error
        }
    }

    async delete(id: string, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest(`/settings/scanner/${id}`, requestId, i18next.t("Scanner deleted."));
            const result = await this.api.delete(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SCANNER_SETTING_DELETE,
                payload: {
                    reload: true,
                    message: ["Scanner deleted."]
                }
            });

        } catch (error) {
            throw error;
        }
    }

    private preparePostPayload(data: any): any {
        const mappings: any[] = [];
        data.mappings.forEach((d: IMapping) => {
            if (d.sampleFieldKey) {
                mappings.push(d)
            }
        });
        return {
            name: data.name,
            isDelimited: data.isDelimited,
            delimiter: data.delimiter,
            mappings,
            isEnabled: data.isEnabled,
            scannerContent: data.scannerContent
        };
    }
    private preparePutPayload(data: any): any {
        const mappings: any[] = [];
        data.mappings.forEach((d: IMapping) => {
            if (d.sampleFieldKey) {
                mappings.push(d)
            }
        });
        return {
            id: data.id,
            name: data.name,
            isDelimited: data.isDelimited,
            delimiter: data.delimiter,
            mappings,
            isEnabled: data.isEnabled,
            scannerContent: data.scannerContent
        };
    }

    private convertResponseData(data: any): ScannerViewData {
        return new ScannerViewData(data.id, data.name, data.scannerContent, data.isDelimited,
            data.delimiter, data.mappings, data.isEnabled);
    }

    private convertResponseListData(data: any) {
        const result: IScannerViewData[] = [];
        if (data.contents) {
            data.contents.forEach((element: { id: string; name: string; description: string; code: string; width: number; }) => {
                result.push(this.convertResponseData(element));
            });
        } else {
            data.forEach((element: { id: string; name: string; description: string; code: string; width: number; }) => {
                result.push(this.convertResponseData(element));
            });
        }
        const tempResult = {
            result: data.contents ? result : result,
            currentPage: data.contents ? data.currentPage : 0,
            totalPages: data.contents ? data.totalPages : 0,
            totalRecords: data.contents ? data.totalRecords : 0
        }
        return tempResult;
    }


}

const scannerActions = new ScannerActions();
export default scannerActions;
